import { Box, LoadingWheel, Text } from "@vinomofo/components";

import { CurrencyLabel } from "../currency";

export const SummaryLine = ({
  label,
  xlLabel,
  subtitle,
  amount,
  showFree = false,
  loading,
  ...rest
}: {
  label: string;
  xlLabel?: boolean;
  subtitle?: string;
  amount: number;
  showFree?: boolean;
  loading?: boolean;
}): JSX.Element => {
  return (
    <Box
      display="flex"
      width="100%"
      justifyContent="space-between"
      alignItems="start"
      padding={3}
      borderTop="1px solid"
      borderTopColor="divider"
      {...rest}
    >
      <Box flex={1}>
        {xlLabel ? (
          <Text fontWeight={500} color="darkMofo" fontSize="14px">
            {label}
          </Text>
        ) : (
          <Text fontSize={1} color="heading">
            {label}
          </Text>
        )}
        <Text fontSize="12px" textTransform="capitalize">
          {subtitle}
        </Text>
      </Box>
      <Box flexGrow={0}>
        {loading ? (
          <LoadingWheel borderWidth="5px" size="2em" />
        ) : (
          <Text fontWeight={500} color="darkMofo" fontSize="14px">
            <CurrencyLabel amount={amount} showFree={showFree} />
          </Text>
        )}
      </Box>
    </Box>
  );
};
